import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20entertainment%20media%20hub%20with%20abstract%20geometric%20shapes%20in%20warm%20coral%20and%20amber%20tones%2C%20soft%20gradient%20background%20with%20cinematic%20lighting%2C%20clean%20contemporary%20design%2C%20streaming%20media%20aesthetic%2C%20professional%20broadcast%20studio%20atmosphere%2C%20high%20contrast%20with%20dark%20shadows%20and%20warm%20highlights&width=1600&height=800&seq=hero-bg-2026-x2&orientation=landscape"
          alt="福利视频网址大全 - 视频资源导航平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            福利视频网址大全
          </h1>
          <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
            汇聚全网最新福利视频网址，提供免费高清视频资源导航，每日更新可用地址，告别失效链接烦恼
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianying"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-film-line mr-2"></i>浏览电影资源
            </Link>
            <Link
              to="/category/zongyi"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white rounded-full font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors border border-white/20 cursor-pointer"
            >
              <i className="ri-tv-line mr-2"></i>综艺娱乐入口
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8">
            {[
              { val: '12,680+', label: '收录网址' },
              { val: '8', label: '资源分类' },
              { val: '每日更新', label: '更新频率' },
              { val: '980万+', label: '累计访问' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-white">{stat.val}</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}